import React from "react";
import "./Homesplash.css";
import Projects from "../../Components/Gallery/Projects";
import sun from "../../Images/vap-sun.png";

export default function Homesplash() {
  return (
    <div className="main-container">
      <div className="seprator"></div>
      <div className="main-title-win">
        <img src={sun} className="sun"></img>

        <div className="main-name toptop">S T A R M A N</div>
        <div className="main-name topout">S T A R M A N</div>
        <div className="main-name outline">S T A R M A N</div>
        <div className="main-name finalname">S T A R M A N</div>
        <div className="subheading">
          web dev &nbsp;|&nbsp; Game dev &nbsp;|&nbsp; Design
        </div>
        <p>(use desktop for best experience)</p>

        <div className="chevron">V</div>
      </div>
      <div className="seprator"></div>
    </div>
  );
}
